<template>
  <div>
    <div class="overlay" @click.prevent="$emit('close')"></div>
    <div class="modal_fixed">
      <div class="new_achievement_box modal_cont" id="wheel_prize_modal">
        <img src="static/images/store/icon-close-back-popup.svg" class="btn_close" @click="$emit('close')">
        <h1>{{ getTranslations.home_modals_notifications_spin_wheel_prize_yeah }}
          <br> {{ getTranslations.home_modals_notifications_spin_wheel_prize_you }} {{ prizeInfo.prizeName }}</h1>
        <img src="static/images/achievements/prize-spin.svg" class="prize_spin_img">
        <button type="" class="claim_prize" @click="$emit('close')">{{ getTranslations.home_modals_notifications_spin_wheel_prize_continue }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

// achievements_modal_wheel_prize.html
export default {
  name: 'spin-wheel-prize',
  props: {
    prizeInfo: Object,
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/spinwheel/SpinWheelPrize.vue